import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"user\"><defs><style type=\"text/css\"></style></defs><path d=\"M501.041 62.931c125.655 0 227.513 100.195 227.513 223.776 0 123.605-101.857 223.805-227.513 223.805-125.65 0-227.506-100.199-227.506-223.805-0.001-123.61 101.89-223.776 227.506-223.776z m0 0c125.655 0 227.513 100.195 227.513 223.776 0 123.605-101.857 223.805-227.513 223.805-125.65 0-227.506-100.199-227.506-223.805-0.001-123.61 101.89-223.776 227.506-223.776z m-85.31 522.194h189.63c162.314 0 293.88 129.388 293.88 289.058v18.622c0 62.922-131.594 65.314-293.88 65.314H415.73c-162.32 0-293.88-0.093-293.88-65.314v-18.622c0.001-159.67 131.56-289.058 293.88-289.058z\" p-id=\"3468\" fill=\"#e6e6e6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/user.svg
// module id = kV7K
// module chunks = 38